import { MDBBtn, MDBModalFooter } from 'mdb-react-ui-kit';
import React from 'react';
import { useTranslation } from 'react-i18next';

function DeleteGroup(props) {
  const { t, i18n } = useTranslation();
  function removeThisGroup(e) {
    e.preventDefault();
    props.setdeleteGroupFlag(true);
    props.onClose();
  }
  return (
    <>
      <div>
        <span className="phrecording">
          {props?.deleteMessage ? (
            <span dangerouslySetInnerHTML={{ __html: props.deleteMessage }} />
          ) : (
            t("removegroup")
          )}
        </span>

      </div>
      <MDBModalFooter>
        <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
          {t("cancel")}
        </MDBBtn>
        <MDBBtn onClick={(e) => {
          e.preventDefault();
          removeThisGroup(e);
        }}>{t("remove")}</MDBBtn>
      </MDBModalFooter>

    </>
  )
}

export default DeleteGroup
